export default "__VITE_ASSET__BIOw0vEg__"